import React, { useEffect, useState } from 'react'
import * as api from '../utils/api/apiClient'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Loading } from '../components/Loading'

const Salary = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [allEmployees, setAllEmployees] = useState([])
  const handleNameClick = (id) => {
    navigate(`/salary/${id}`)
  }

  console.log(allEmployees)

  const fetchAllEmployee = async () => {
    try {
      const res = await api.getAllEmployees()
      setAllEmployees(res.data.employees)
    } catch (error) {
      console.error(error)
      setAllEmployees([])
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message)
      }
    }
  }

  useEffect(() => {
    fetchAllEmployee()
    setTimeout(() => {
      setLoading(true)
    }, 400) // 5 seconds
  }, [])
  return (
    <>
      {!loading && <Loading />}
      <div className='bg-cream min-h-screen p-6'>
        {/* Header */}
        <header className='bg-tan text-white p-4 rounded-md shadow-md'>
          <h1 className='text-2xl font-bold'>Employee Salary</h1>
        </header>

        {/* Scrollable Table Container */}
        <section className='mt-6 bg-white p-4 rounded-md shadow-md'>
          <div className='overflow-hidden rounded-md border border-light_gray'>
            <div className='overflow-y-auto max-h-96'>
              <table className='w-full border-collapse border border-light_gray'>
                <thead className='bg-beige text-black sticky top-0'>
                  <tr>
                    <th className='border border-light_gray p-2'>ID</th>
                    <th className='border border-light_gray p-2'>Name</th>
                    <th className='border border-light_gray p-2'>Email</th>
                    <th className='border border-light_gray p-2'>Phone</th>
                    <th className='border border-light_gray p-2'>
                      Basic Salary
                    </th>
                    <th className='border border-light_gray p-2'>Level</th>
                    <th className='border border-light_gray p-2'>Adhar</th>
                    <th className='border border-light_gray p-2'>Pan</th>
                  </tr>
                </thead>
                <tbody className='cursor-pointer'>
                  {allEmployees.map((employee) => (
                    <tr
                      key={employee.id}
                      onClick={() => handleNameClick(employee.id)} // Wrap the function in an anonymous function
                      className={
                        employee.payment_done ? 'bg-light_gray' : 'bg-white'
                      }
                    >
                      <td className='border border-light_gray p-2 text-center'>
                        {employee.work_id}
                      </td>
                      <td className='border border-light_gray p-2 text-center'>
                        {employee.name}
                      </td>
                      <td className='border border-light_gray p-2 text-center'>
                        {employee.email}
                      </td>
                      <td className='border border-light_gray p-2 text-center'>
                        {employee.phone_number}
                      </td>
                      <td className='border border-light_gray p-2 text-center text-gold'>
                        ₹{employee.salary}
                      </td>
                      <td className='border border-light_gray p-2 text-center text-gold'>
                        {employee.post}
                      </td>
                      <td className='border border-light_gray p-2 text-center '>
                        {employee.aadhar}
                      </td>
                      <td className='border border-light_gray p-2 text-center'>
                        {employee.pan_number}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default Salary
